(function () {
	'use strict';

	angular.module('app.shell').directive('edFooterSimple', [edFooterSimple]);

	function edFooterSimple() {
		var directive = {
			// controller: ['$scope', '$rootScope', controller],
			templateUrl: '/app/content/footer/edFooterSimple.html',
			// restrict: 'EA',
			// scope: {},
		};
		return directive;

		// function controller($scope, $rootScope) {
		// 	$scope.lang = $rootScope.lang;


		// }
	}
})();
